// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { DistributeTopLevelOptions } from '../Enums/DistributeTopLevelOptions';
export class AdvancedOptions {
  useCustomTechFeesText: boolean;
  technologyFeesText: string;
  useCustomRiskText: boolean;
  riskText: string;
  distributeTopLevel: boolean;
  distributeTopLevelOption: DistributeTopLevelOptions;
  selectedAreaId: string;
  useCustomProjectManagerLaborText: boolean;
  projectManagerLaborText: string;
  useCustomEngineeringLaborText: boolean;
  engineeringLaborText: string;
  useCustomSpecialistLaborText: boolean;
  specialistLaborText: string;
  useCustomMechanicalLaborText: boolean;
  mechanicalLaborText: string;
  useCustomElectricalLaborText: boolean;
  useCustomNENGLaborText: boolean;
  nengLaborText: string;
  useCustomQENGLaborText: boolean;
  qengLaborText: string;
  useCustomCENGLaborText: boolean;
  cengLaborText: string;
  useCustomEENGLaborText: boolean;
  eengLaborText: string;
  useCustomLENGLaborText: boolean;
  lengLaborText: string;
  useCustomGRAPLaborText: boolean;
  grapLaborText: string;
  useCustomPROGLaborText: boolean;
  progLaborText: string;
  useCustomDDSLaborText: boolean;
  ddsLaborText: string;
  electricalLaborText: string;
  useCustomSubcontractorFeesText: boolean;
  subcontractorFeesText: string;
  useCustomProductivityReserveText: boolean;
  productivityReserveFeesText: string;
  useCustomMechanicalFeeText: boolean;
  mechanicalFeesText: string;
}
